import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { getApiUrl, API_CONFIG } from '../config/api';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface DecodedToken {
  sub: string;
  username: string;
  exp: number;
  iat: number;
}

const TOKEN_KEY = 'acasa_auth_token';

export const authService = {
  // Get token from localStorage
  getToken: (): string | null => {
    return localStorage.getItem(TOKEN_KEY);
  },

  // Set token in localStorage
  setToken: (token: string): void => {
    localStorage.setItem(TOKEN_KEY, token);
  },

  // Remove token from localStorage
  removeToken: (): void => {
    localStorage.removeItem(TOKEN_KEY);
  },

  // Check if token is valid and not expired
  isTokenValid: (token: string): boolean => {
    try {
      const decoded = jwtDecode<DecodedToken>(token);
      const currentTime = Date.now() / 1000;
      return decoded.exp > currentTime;
    } catch {
      return false;
    }
  },

  // Decode token to get user info
  decodeToken: (token: string): DecodedToken | null => {
    try {
      return jwtDecode<DecodedToken>(token);
    } catch {
      return null;
    }
  },

  // Login API call
  login: async (credentials: LoginCredentials): Promise<string> => {
    try {
      const response = await axios.post(
        getApiUrl(API_CONFIG.ENDPOINTS.LOGIN), 
        credentials,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      
      if (response.data && response.data.token) {
        return response.data.token;
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 401) {
          throw new Error('Invalid credentials');
        } else if (error.response?.status === 500) {
          throw new Error('Server error');
        } else {
          throw new Error('Network error');
        }
      }
      throw error;
    }
  }
}; 